export const SET_BUNDLES = 'SET_BUNDLES'
export const ADD_BUNDLE = 'ADD_BUNDLE'
export const UPDATE_BUNDLE = 'UPDATE_BUNDLE'
export const DELETE_BUNDLE = 'DELETE_BUNDLE'
export const SET_IMAGE = 'SET_IMAGE'

export const SET_SHOP_BUNDLES = 'SET_SHOP_BUNDLES'
export const ADD_SHOP_BUNDLE = 'ADD_SHOP_BUNDLE'
export const UPDATE_SHOP_BUNDLE = 'UPDATE_SHOP_BUNDLE'
export const DELETE_SHOP_BUNDLE = 'DELETE_SHOP_BUNDLE'
